import {
  REQUEST_CASE_INFO_RESULTS,
  RECEIVE_CASE_INFO_RESULTS,
  ERROR_CASE_INFO_RESULTS,

  REQUEST_POLICY_INFO_RESULTS,
  RECEIVE_POLICY_INFO_RESULTS,
  ERROR_POLICY_INFO_RESULTS,

  REQUEST_CASE_NOTES_RESULTS,
  RECEIVE_CASE_NOTES_RESULTS,
  ERROR_CASE_NOTES_RESULTS,

  CONTROLID_CHANGE,

  REQUEST_ASSIGNABLE_APPRAISER_LIST,
  RECEIVE_ASSIGNABLE_APPRAISER_LIST,
  ERROR_ASSIGNABLE_APPRAISER_LIST,

  REQUEST_CHANGE_APPRAISER,
  RECEIVE_CHANGE_APPRAISER,
  ERROR_CHANGE_APPRAISER,

  REQUEST_CASE_CONVERSION_OPTIONS,
  RECEIVE_CASE_CONVERSION_OPTIONS,
  ERROR_CASE_CONVERSION_OPTIONS,

  REQUEST_CASE_CONVERSION,
  RECEIVE_CASE_CONVERSION,
  ERROR_CASE_CONVERSION,
} from 'typeConstants';
import { caseDetails as initialState } from '../../initialState.tsx';

const caseDetails = (state = initialState, action) => {

  switch (action.type) {
    case REQUEST_POLICY_INFO_RESULTS:
      return {
        ...state,
        fetchingPolicy: true
      };
    case REQUEST_CASE_INFO_RESULTS:
      return {
        ...state,
        fetchingCase: true
      };
    case REQUEST_CASE_NOTES_RESULTS:
      return {
        ...state,
        fetchingNotes: true
      };
    case RECEIVE_POLICY_INFO_RESULTS:
      return {
        ...state,
        policyInfo: action.payload,
        fetchingPolicy: false
      };
    case RECEIVE_CASE_INFO_RESULTS:
      return {
        ...state,
        caseInfo: action.payload,
        fetchingCase: false
      };
    case RECEIVE_CASE_NOTES_RESULTS:
      return {
        ...state,
        caseNotes: action.payload,
        fetchingNotes: false
      };
    case ERROR_POLICY_INFO_RESULTS:
      return {
        ...state,
        policyInfo: {},
        fetchingPolicy: false
      };
    case ERROR_CASE_INFO_RESULTS:
      return {
        ...state,
        policyInfo: {},
        fetchingCase: false
      };
    case ERROR_CASE_NOTES_RESULTS:
      return {
        ...state,
        caseNotes: {},
        fetchingNotes: false
      };
    case CONTROLID_CHANGE:
      return {
        ...state,
        controlNumber: action.payload,
      };
    case REQUEST_ASSIGNABLE_APPRAISER_LIST:
      return {
        ...state,
        isFetchingAssignableAppraisers: true
      };
    case RECEIVE_ASSIGNABLE_APPRAISER_LIST:
      return {
        ...state,
        assignableAppraisers: action.payload,
        isFetchingAssignableAppraisers: false
      };
    case ERROR_ASSIGNABLE_APPRAISER_LIST:
      return {
        ...state,
        isFetchingAssignableAppraisers: false
      };
    case REQUEST_CHANGE_APPRAISER:
      return {
        ...state,
        isChangingAppraiserAssigned: true
      };
    case RECEIVE_CHANGE_APPRAISER:
      return {
        ...state,
        isChangingAppraiserAssigned: false
      };
    case ERROR_CHANGE_APPRAISER:
      return {
        ...state,
        isChangingAppraiserAssigned: false
      };
    case REQUEST_CASE_CONVERSION_OPTIONS:
      return {
        ...state
      };
    case RECEIVE_CASE_CONVERSION_OPTIONS:
      return {
        ...state,
        caseConversionOptions: (action.payload || []).map(({ code, name }) => ({
          value: code,
          label: name,
        }))
      };
    case ERROR_CASE_CONVERSION_OPTIONS:
      return {
        ...state,
      };
    case REQUEST_CASE_CONVERSION:
      return {
        ...state,
      };
    case RECEIVE_CASE_CONVERSION:
      return {
        ...state,
      };
    case ERROR_CASE_CONVERSION:
      return {
        ...state,
      };
    default:
      return state;
  }
};

export default caseDetails;
